(() => {
  const STUDIO_VERSION = 'v1';

  const installSidebarRailStyles = () => {
    if (document.getElementById('ale-studio-sidebar-rail-styles')) return;

    const style = document.createElement('style');
    style.id = 'ale-studio-sidebar-rail-styles';
    style.textContent = `
      /* v5.43 — Studio sidebar + hero eyebrow polish */
      @media (min-width: 1024px) {
        :root {
          --ale-studio-sidebar-collapsed-width: 72px;
          --ale-studio-sidebar-expanded-width: 272px;
          --ale-studio-sidebar-width: var(--ale-studio-sidebar-collapsed-width);
        }

        body.ale-studio-sidebar-expanded {
          --ale-studio-sidebar-width: var(--ale-studio-sidebar-expanded-width);
        }

        body.ale-studio-home-page #MainContent,
        body.ale-studio-home-page #ALEGlobalFooter {
          transition:
            margin-left .24s cubic-bezier(.2,.75,.25,1),
            width .24s cubic-bezier(.2,.75,.25,1),
            max-width .24s cubic-bezier(.2,.75,.25,1);
        }

        body.ale-studio-home-page:not(.ale-studio-sidebar-expanded) #MainContent {
          margin-left: var(--ale-studio-sidebar-collapsed-width) !important;
          width: calc(100% - var(--ale-studio-sidebar-collapsed-width)) !important;
          max-width: calc(100% - var(--ale-studio-sidebar-collapsed-width)) !important;
        }

        body.ale-studio-home-page:not(.ale-studio-sidebar-expanded) #ALEGlobalFooter {
          margin-left: var(--ale-studio-sidebar-collapsed-width) !important;
          width: calc(100% - var(--ale-studio-sidebar-collapsed-width)) !important;
          max-width: calc(100% - var(--ale-studio-sidebar-collapsed-width)) !important;
        }

        body.ale-studio-home-page.ale-studio-sidebar-expanded #MainContent {
          margin-left: var(--ale-studio-sidebar-expanded-width) !important;
          width: calc(100% - var(--ale-studio-sidebar-expanded-width)) !important;
          max-width: calc(100% - var(--ale-studio-sidebar-expanded-width)) !important;
        }

        body.ale-studio-home-page.ale-studio-sidebar-expanded #ALEGlobalFooter {
          margin-left: var(--ale-studio-sidebar-expanded-width) !important;
          width: calc(100% - var(--ale-studio-sidebar-expanded-width)) !important;
          max-width: calc(100% - var(--ale-studio-sidebar-expanded-width)) !important;
        }

        .ale-studio-sidebar {
          width: var(--ale-studio-sidebar-collapsed-width) !important;
          max-width: var(--ale-studio-sidebar-collapsed-width) !important;
          overflow-x: hidden;
          padding: 12px 12px 24px;
          scrollbar-width: none;
          -ms-overflow-style: none;
          transition:
            width .24s cubic-bezier(.2,.75,.25,1),
            max-width .24s cubic-bezier(.2,.75,.25,1),
            padding .24s cubic-bezier(.2,.75,.25,1);
        }

        .ale-studio-sidebar::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar {
          width: var(--ale-studio-sidebar-expanded-width) !important;
          max-width: var(--ale-studio-sidebar-expanded-width) !important;
          padding: 16px 24px 28px;
        }

        .ale-studio-sidebar__toggle {
          display: grid;
          place-items: center;
          width: 46px;
          height: 46px;
          margin: 0 auto 6px;
          padding: 0;
          border: 0;
          border-radius: 0;
          background: transparent;
          color: var(--ale-studio-sidebar-text, #fff);
          cursor: pointer;
          translate: -7px 0;
        }

        .ale-studio-sidebar__toggle:hover,
        .ale-studio-sidebar__toggle:focus-visible {
          background: rgba(255,255,255,.06);
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar__toggle {
          margin: 0 0 6px 14px;
          translate: -7px 0;
        }

        .ale-studio-sidebar__toggle:focus-visible {
          outline: 2px solid var(--ale-studio-accent);
          outline-offset: 2px;
        }

        .ale-studio-sidebar__toggle svg {
          width: 25px;
          height: 25px;
          fill: none;
          stroke: currentColor;
          stroke-width: 1.15;
          stroke-linecap: round;
          stroke-linejoin: round;
          transition: transform .24s cubic-bezier(.2,.75,.25,1);
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar__toggle svg {
          transform: rotate(180deg);
        }

        /* Brand lockup has moved out of the rail; keep the sidebar navigation utility-first. */
        .ale-studio-sidebar__brand {
          display: none !important;
        }

        .ale-studio-sidebar .ale-studio-nav__item {
          grid-template-columns: 1fr;
          gap: 0;
          min-height: 46px;
          padding: 7px 0;
          justify-items: center;
        }

        .ale-studio-sidebar .ale-studio-nav__item > span:last-child {
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          padding: 0 !important;
          margin: -1px !important;
          overflow: hidden !important;
          clip: rect(0,0,0,0) !important;
          white-space: nowrap !important;
          border: 0 !important;
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar .ale-studio-nav__item {
          grid-template-columns: 30px minmax(0,1fr);
          gap: 12px;
          padding: 7px 8px 7px 14px;
          justify-items: stretch;
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar .ale-studio-nav__item > span:last-child {
          position: static !important;
          width: auto !important;
          height: auto !important;
          padding: 0 !important;
          margin: 0 !important;
          overflow: visible !important;
          clip: auto !important;
          white-space: normal !important;
          border: 0 !important;
        }

        .ale-studio-sidebar .ale-studio-nav__divider {
          width: 32px;
          margin: 14px auto;
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar .ale-studio-nav__divider {
          width: auto;
          margin: 14px 6px;
        }

        .ale-studio-sidebar .ale-studio-nav__active-bar {
          left: -12px;
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar .ale-studio-nav__active-bar {
          left: -24px;
        }

        .ale-studio-sidebar .ale-studio-nav__item--nested {
          padding-left: 0;
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar .ale-studio-nav__item--nested {
          padding-left: 14px;
        }
      }

      /* ALE eyebrow treatment: yellow rule + Warwick quatrefoil. */
      .ale-studio-eyebrow {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        width: auto;
      }

      .ale-studio-eyebrow::before {
        content: '';
        display: block;
        flex: 0 0 28px;
        width: 28px;
        height: 2px;
        background: var(--ale-studio-accent, #fac400);
      }

      .ale-studio-eyebrow::after {
        content: '';
        display: block;
        flex: 0 0 16px;
        width: 16px;
        height: 16px;
        background-image: url('https://cdn.shopify.com/s/files/1/0663/5077/6414/files/ale-warwick-quatrefoil.png?v=1789580631');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }

      @media (max-width: 767px) {
        .ale-studio-eyebrow {
          gap: 8px;
        }

        .ale-studio-eyebrow::before {
          flex-basis: 22px;
          width: 22px;
        }

        .ale-studio-eyebrow::after {
          flex-basis: 14px;
          width: 14px;
          height: 14px;
        }
      }

      @media (min-width: 1024px) and (max-width: 1279px) {
        :root {
          --ale-studio-sidebar-expanded-width: 260px;
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar {
          padding-inline: 20px;
        }

        body.ale-studio-sidebar-expanded .ale-studio-sidebar .ale-studio-nav__active-bar {
          left: -20px;
        }
      }

      @media (prefers-reduced-motion: reduce) and (min-width: 1024px) {
        body.ale-studio-home-page #MainContent,
        body.ale-studio-home-page #ALEGlobalFooter,
        .ale-studio-sidebar,
        .ale-studio-sidebar__toggle svg {
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  installSidebarRailStyles();

  const initStudio = (root) => {
    if (!root || root.dataset.aleStudioInitialized === 'true') return;
    root.dataset.aleStudioInitialized = 'true';
    root.classList.add('js-enabled');

    const openButton = root.querySelector('[data-ale-menu-open]');
    const closeButton = root.querySelector('[data-ale-menu-close]');
    const drawer = root.querySelector('[data-ale-menu-drawer]');
    const backdrop = root.querySelector('[data-ale-menu-backdrop]');
    const heroEyebrow = root.querySelector('.ale-studio-eyebrow');
    let lastFocused = null;

    if (heroEyebrow) heroEyebrow.textContent = 'Welcome to A Lovely Everyday';

    const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const deviceLayout = () => window.matchMedia('(max-width: 1023px)').matches ? 'mobile_or_tablet' : 'desktop';

    // Harden mobile hit testing: a stale/invisible backdrop must never block Studio Home links.
    if (backdrop) {
      backdrop.classList.remove('is-open');
      backdrop.hidden = true;
    }
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    openButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ale-studio-menu-open');

    const analyticsContext = (extra = {}) => ({
      studio_version: STUDIO_VERSION,
      source_location: 'studio_home',
      device_layout: deviceLayout(),
      page_location: `${window.location.origin}${window.location.pathname}`,
      page_title: document.title || 'The Experience Studio',
      ...extra
    });

    const emit = (eventName, params = {}) => {
      const payload = analyticsContext(params);
      const send = () => {
        try {
          if (window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish(eventName, payload);
            return true;
          }
        } catch (error) {
          console.warn('[ALE Studio] Analytics publish failed.', error);
        }
        return false;
      };

      // Local/theme-editor fallback for debugging only. The production GA4 path is Shopify Customer Events -> Custom Pixel -> GTM -> GA4.
      if (!send()) {
        window.setTimeout(() => {
          if (!send()) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: eventName, ...payload });
          }
        }, 350);
      }
    };

    // Desktop Studio sidebar: always begin as a slim icon rail on every page load.
    const desktopSidebarMq = window.matchMedia('(min-width: 1024px)');
    const sidebar = root.querySelector('.ale-studio-sidebar');
    let sidebarToggle = root.querySelector('[data-ale-sidebar-toggle]');

    if (sidebar && !sidebarToggle) {
      sidebarToggle = document.createElement('button');
      sidebarToggle.type = 'button';
      sidebarToggle.className = 'ale-studio-sidebar__toggle';
      sidebarToggle.dataset.aleSidebarToggle = '';
      sidebarToggle.setAttribute('aria-expanded', 'false');
      sidebarToggle.setAttribute('aria-label', 'Expand Studio menu');
      sidebarToggle.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M4 16h23"></path><path d="m20 9 7 7-7 7"></path></svg>';
      sidebar.prepend(sidebarToggle);
    }

    const setSidebarExpanded = (expanded, shouldEmit = true) => {
      const isExpanded = desktopSidebarMq.matches && Boolean(expanded);
      document.body.classList.toggle('ale-studio-sidebar-expanded', isExpanded);
      root.classList.toggle('is-sidebar-expanded', isExpanded);

      if (sidebarToggle) {
        sidebarToggle.setAttribute('aria-expanded', String(isExpanded));
        sidebarToggle.setAttribute('aria-label', isExpanded ? 'Collapse Studio menu' : 'Expand Studio menu');
      }

      if (shouldEmit) emit('ale_studio_sidebar_toggle', { expanded: isExpanded });
    };

    setSidebarExpanded(false, false);

    sidebarToggle?.addEventListener('click', () => {
      setSidebarExpanded(sidebarToggle.getAttribute('aria-expanded') !== 'true');
    });

    const resetSidebarForLayoutChange = () => setSidebarExpanded(false, false);
    if (typeof desktopSidebarMq.addEventListener === 'function') {
      desktopSidebarMq.addEventListener('change', resetSidebarForLayoutChange);
    } else if (typeof desktopSidebarMq.addListener === 'function') {
      desktopSidebarMq.addListener(resetSidebarForLayoutChange);
    }

    const closeMenu = ({ restoreFocus = true } = {}) => {
      if (!drawer || !backdrop || !openButton) return;
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ale-studio-menu-open');
      window.setTimeout(() => {
        if (!backdrop.classList.contains('is-open')) backdrop.hidden = true;
      }, 280);
      if (restoreFocus && lastFocused instanceof HTMLElement) lastFocused.focus({ preventScroll: true });
    };

    const openMenu = () => {
      if (!drawer || !backdrop || !openButton) return;
      lastFocused = document.activeElement;
      backdrop.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        backdrop.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ale-studio-menu-open');
      const firstFocusable = drawer.querySelector(focusableSelector);
      if (firstFocusable instanceof HTMLElement) firstFocusable.focus({ preventScroll: true });
      emit('ale_studio_mobile_menu_open', { nav_mode: 'drawer' });
    };

    openButton?.addEventListener('click', openMenu);
    closeButton?.addEventListener('click', () => closeMenu());
    backdrop?.addEventListener('click', () => closeMenu());

    drawer?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll(focusableSelector)].filter((el) => !el.hasAttribute('hidden'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    drawer?.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => closeMenu({ restoreFocus: false }));
    });

    root.querySelectorAll('[data-ale-track]').forEach((element) => {
      element.addEventListener('click', () => {
        const rawEventName = element.dataset.aleTrack;
        if (!rawEventName) return;
        const eventName = rawEventName.startsWith('ale_studio_') ? rawEventName : `ale_${rawEventName}`;
        const params = {
          destination: element.dataset.aleDestination || '',
          link_url: element.href || ''
        };

        if (rawEventName === 'studio_nav_click') {
          params.nav_group = element.closest('.ale-studio-nav__group--secondary') ? 'secondary' : 'primary';
          params.nav_mode = element.closest('.ale-studio-drawer') ? 'drawer' : 'sidebar';
        }
        if (rawEventName === 'studio_experience_select') {
          const cards = [...root.querySelectorAll('.ale-studio-card')];
          params.card_position = cards.indexOf(element) + 1;
        }
        if (element.dataset.aleUpdateStatus) params.update_status = element.dataset.aleUpdateStatus;
        if (element.dataset.aleUpdateSlot) params.home_slot = Number(element.dataset.aleUpdateSlot) || 0;
        if (element.dataset.aleUpdateSlug) params.update_slug = element.dataset.aleUpdateSlug;

        emit(eventName, params);
      });
    });

    // One-time section exposure events help answer whether visitors reach the experiences and lower GUI row.
    if ('IntersectionObserver' in window) {
      const seen = new Set();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
          const sectionName = entry.target.dataset.aleSectionView;
          if (!sectionName || seen.has(sectionName)) return;
          seen.add(sectionName);
          emit('ale_studio_section_view', { section_name: sectionName });
          observer.unobserve(entry.target);
        });
      }, { threshold: [0.35] });
      root.querySelectorAll('[data-ale-section-view]').forEach((el) => observer.observe(el));
    }

    requestAnimationFrame(() => {
      root.classList.add('is-ready');
      emit('ale_studio_home_view');
    });
  };

  const initAll = () => document.querySelectorAll('[data-ale-studio-home]').forEach(initStudio);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initStudio(event.target.querySelector?.('[data-ale-studio-home]') || (event.target.matches?.('[data-ale-studio-home]') ? event.target : null));
  });
})();

(() => {
  document.querySelectorAll('[data-ale-home-update-count]').forEach((el) => {
    const section = el.closest('.ale-studio-updates');
    const count = section?.querySelectorAll('.ale-studio-update').length || 0;
    el.textContent = `${String(count).padStart(2, '0')} ${count === 1 ? 'Update' : 'Updates'}`;
  });
})();
